import { api } from "./dataService";

export const fetchInsurerContacts = async (insurer_id) => {
  return (await api.get(`data/insurers/${insurer_id}/contacts`)).data;
};

export const createInsurerContact = async (insurer_id, payload) => {
  return (await api.post(`data/insurers/${insurer_id}/contacts`, payload)).data;
};

export const updateInsurerContact = async (insurer_id, contact_id, payload) => {
  return (
    await api.patch(`data/insurers/${insurer_id}/contacts/${contact_id}`, payload)
  ).data;
};

export const makeInsurerContactDefault = async (insurer_id, contact_id) => {
  return (
    await api.post(`data/insurers/${insurer_id}/contacts/${contact_id}/default`)
  ).data;
};

export const deleteInsurerContact = async (insurer_id, contact_id) => {
  await api.delete(`data/insurers/${insurer_id}/contacts/${contact_id}`);
};

/**
 * Creates a contact for the insurer of the given claim. Rejects with the axios
 * error; a 422 carries errors.email when the insurer already has that address.
 */
export const createInsurerContactFromClaim = async (claim_id, payload) => {
  return (await api.post(`data/claims/${claim_id}/insurer-contacts`, payload)).data;
};
